export default __webpack_public_path__ + "media/images/dividers/footer-divider-4260c2c3cf5c010712781cb9b3a1201b.svg";